import axios from '@/utils/request'
// 修改模板
export const setTemplate = (data)=>{
  return axios.request({
     url: '/v1/point_mall/createTemplate',
     method: 'post',
     data
   })
 };

// 获取积分商城模板
export const getTemplateDetail = (params)=>{
  return axios.request({
     url: '/v1/point_mall/template',
     method: 'get',
     params
   })
 };

 // 获取分组管理 - 分组列表
export const getCategory = (params)=>{
  return axios.request({
     url: '/v1/exchangeGift/category/list',
     method: 'get',
     params
   })
 };
 // 获取分组管理 -添加分类
 export const createCategory = (data)=>{
  return axios.request({
     url: '/v1/exchangeGift/category/create',
     method: 'post',
     data
   })
 };

  // 获取分组管理 -修改分类
  export const updateCate = (data)=>{
    return axios.request({
       url: '/v1/exchangeGift/category/update',
       method: 'post',
       data
     })
   };



   // 获取分组管理 -删除分类
   export const deleteCate = (data)=>{
    return axios.request({
       url: '/v1/exchangeGift/category/delete',
       method: 'post',
       data
     })
   };

   
   // 兑换礼品订单管理 - 概括
export const exchangeGiftGeneral = (params)=>{
  return axios.request({
     url: '/v1/exchange_gift/general',
     method: 'get',
     params
   })
 };
// -批量修改分类
  export const updateAllCate = (data)=>{
    return axios.request({
       url: '/v1/exchange_gift/setCategoryAll',
       method: 'post',
       data
     })
   };
   
// 兑换分析
export const giftAnalysis = (params)=>{
  return axios.request({
     url: '/v1/exchange_gift/giftAnalysis',
     method: 'get',
     params
   })
 };
   
// 兑换礼品列表
export const exchangeGift = (params)=>{
  return axios.request({
     url: '/v1/exchange_gift/exchangeGift',
     method: 'get',
     params
   })
 };

// 批量设置运费模板
export const setDeliveryAll = (data)=>{
  return axios.request({
     url: '/v1/exchange_gift/setDeliveryAll',
     method: 'post',
     data
   },{
    'Content-Type':'multipart/form-data'
   })
 };

// 批量上下架
export const setExchangeState = (data)=>{
  return axios.request({
    url: '/v1/exchange_gift/state',
    method: 'post',
    data
  })
};
// 兑换礼品 - 添加
export const exchangeGiftAdd = (data)=>{
  return axios.request({
    url: '/v1/exchange_gift/exchangeGift',
    method: 'post',
    data
  })
};
// 兑换礼品 - 编辑
export const exchangeGiftEdit = (data)=>{
  return axios.request({
    url: '/v1/exchange_gift/exchangeGift/'+data.id,
    method: 'PUT',
    data
  })
};
// 兑换礼品 - 详情
export const exchangeGiftMore = (id)=>{
  return axios.request({
    url: '/v1/exchange_gift/exchangeGift/'+id,
    method: 'get'
  })
};
// 兑换礼品 - 修改兑换价格
export const editGiftPrice = (data)=>{
  return axios.request({
    url: '/v1/exchange_gift/editPrice',
    method: 'post',
    data
  })
};
// 兑换礼品 - 编辑库存
export const editGiftStock = (data)=>{
  return axios.request({
    url: '/v1/exchange_gift/exchangeGift/edit',
    method: 'post',
    data
  })
};

//商品统计
export const productStatistics = (params)=>{
  return axios.request({
    url: '/v1/exchange_gift/productStatistics',
    method: 'get',
    params
  })
};

//消费统计
export const consumerStatistics = (params)=>{
  return axios.request({
    url: '/v1/exchange_gift/consumerStatistics',
    method: 'get',
    params
  })
};


